
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 3000 3000","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-mercury",attrs:{"d":"M1643.61 1292.31a252.531 252.531 0 0 1 76.75 84.42 252.408 252.408 0 0 1 31.77 109.59c2.09 38.47-4.66 76.91-19.72 112.38a252.509 252.509 0 0 1-67.17 92.22 252.455 252.455 0 0 1-100.91 53.25 252.698 252.698 0 0 1-114.05 3.39 252.57 252.57 0 0 1-103.89-47.16 252.493 252.493 0 0 1-72.53-88.08","stroke":"#F6FBE5","stroke-width":"37"}}),_c('circle',{staticClass:"i-sun",attrs:{"cx":"1500","cy":"1500","r":"128","fill":"#F7FAFA"}}),_c('path',{staticClass:"i-venus",attrs:{"d":"M1037.02 1280.21a512.415 512.415 0 0 1 139.03-177.34 512.555 512.555 0 0 1 201.66-100.57 512.525 512.525 0 0 1 576.45 260.21 512.658 512.658 0 0 1 57.96 217.76 512.505 512.505 0 0 1-173.15 404.12","stroke":"#09A098","stroke-dasharray":"3 10"}}),_c('path',{staticClass:"i-earth",attrs:{"d":"M1184.65 2661.26c-275.033-74.69-514.629-244.57-676.124-479.38-161.495-234.82-234.404-519.34-205.744-802.89","stroke":"#F9A241","stroke-width":"2","stroke-dasharray":"12 24"}})])
          )
        }
      }
    